export default __webpack_public_path__ + "static/media/telegram.13348ad0.svg";